import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function ContactPage() {
  return (
    <>
      <Header />
      <main className="contact-page">
        <section className="contact-hero">
          <h1>Let's have a coffee!</h1>
          <p>Tell us a bit about yourself, and we'll reach out to discuss your needs.</p>
        </section>

        <section className="form-section">
          <form action="https://formspree.io/f/xojrwkol" method="POST" className="contact-form">
            <div className="field-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" placeholder="Your full name" required />
            </div>

            <div className="field-group">
              <label htmlFor="phone">Phone Number</label>
              <input type="tel" id="phone" name="phone" placeholder="Best number to reach you" required />
            </div>

            <div className="field-group">
              <label htmlFor="company">Company Name</label>
              <input type="text" id="company" name="company" placeholder="Your organization" required />
            </div>

            <button type="submit" className="btn-primary">Send Request</button>
          </form>
        </section>
      </main>
      <Footer />
    </>
  );
}
